<template>
  <aside class="gs-asset-sidebar">
    <div class="gs-asset-sidebar__heading">
      <span>ASSET TYPES</span>
      <span class="gs-asset-sidebar__counter">{{ enabledCount }} / {{ items.length }} enabled</span>
    </div>
    <button type="button" class="gs-asset-sidebar__item" :class="{ 'is-active': current === 'portalSettings' }" :aria-current="current === 'portalSettings' ? 'true' : null" @click="$emit('select', 'portalSettings')">
      <gs-icon name="settings" size="16" />
      <span class="gs-asset-sidebar__label">Portal Settings</span>
    </button>
    <button
      v-for="item in items"
      :key="item.value"
      type="button"
      class="gs-asset-sidebar__item"
      :class="{
        'is-active': item.value === current,
        'is-enabled': item.enabled,
        'has-error': item.error,
      }"
      :aria-current="item.value === current ? 'true' : null"
      @click="$emit('select', item.value)"
    >
      <span class="gs-asset-sidebar__dot" aria-hidden="true"></span>
      <span class="gs-asset-sidebar__label">{{ item.label }}</span>
      <span class="gs-asset-sidebar__count">{{ item.count }}</span>
    </button>
  </aside>
</template>

<script>
export default {
  name: 'AssetSidebar',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    current: {
      type: String,
      default: '',
    },
  },
  computed: {
    enabledCount() {
      return this.items.filter((item) => item.enabled).length;
    },
  },
};
</script>

<style scoped>
.gs-asset-sidebar {
  position: sticky;
  top: 88px;
  align-self: start;
  min-width: 0;
}

.gs-asset-sidebar__heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin: 0 12px 8px;
  color: var(--gs-muted-foreground);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  line-height: 1;
}

.gs-asset-sidebar__counter {
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  letter-spacing: 0;
  white-space: nowrap;
}

.gs-asset-sidebar__item {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  min-height: 40px;
  padding: 6px 12px;
  color: var(--gs-muted-foreground);
  font-size: 15px;
  font-weight: 500;
  line-height: 1.25;
  text-align: left;
  background: transparent;
  border: 0;
  border-left: 3px solid transparent;
  border-radius: var(--gs-radius-sm);
  cursor: pointer;
  transition: background-color 120ms ease, color 120ms ease;
}

.gs-asset-sidebar__item:hover {
  color: var(--gs-foreground);
  background: var(--gs-muted);
}

.gs-asset-sidebar__item:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px var(--gs-ring);
}

.gs-asset-sidebar__item.is-active {
  color: var(--gs-foreground);
  font-weight: 700;
  background: var(--gs-primary-soft);
  border-left-color: var(--gs-primary);
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.gs-asset-sidebar__item.has-error {
  color: var(--gs-danger);
}

.gs-asset-sidebar__dot {
  display: inline-block;
  flex: 0 0 auto;
  width: 10px;
  height: 10px;
  border: 1.5px solid var(--gs-border-strong);
  border-radius: 999px;
  background: transparent;
}

.gs-asset-sidebar__item.is-active .gs-asset-sidebar__dot {
  border-color: var(--gs-primary);
}

.gs-asset-sidebar__item.is-enabled .gs-asset-sidebar__dot {
  border-color: var(--gs-success);
  background: var(--gs-success);
}

.gs-asset-sidebar__item.has-error .gs-asset-sidebar__dot {
  border-color: var(--gs-danger);
  background: var(--gs-danger);
}

.gs-asset-sidebar__label {
  min-width: 0;
  flex: 1 1 auto;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.gs-asset-sidebar__count {
  flex: 0 0 auto;
  min-width: 22px;
  padding: 2px 7px;
  color: var(--gs-muted-foreground);
  font-size: 11px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  text-align: center;
  background: var(--gs-muted);
  border-radius: 999px;
}

.gs-asset-sidebar__item.is-active .gs-asset-sidebar__count {
  color: var(--gs-primary);
  background: var(--gs-surface);
}

@media (max-width: 900px) {
  .gs-asset-sidebar {
    position: static;
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
  }

  .gs-asset-sidebar__heading {
    width: 100%;
    margin-left: 0;
  }

  .gs-asset-sidebar__item {
    width: auto;
  }
}
</style>
